import $store from '../../store'

/** 用来本地存储和取值删除功能,传一个值是get两个值是set
 * @method cache
 * @param {string} key 本地存键key值
 * @param {string} val 存储的值 传null值相当于清除函数
 */
export const cache = (key, val, timeOver = 0) => {
  if (val || val === null || val === 0) {
    val === null
      ? localStorage.removeItem(key)
      : localStorage.setItem(key, JSON.stringify({
        timeOver,
        data: val
      }))
    // 这个是取值
  } else {
    let value = localStorage.getItem(key)
    try {
      let obj = JSON.parse(value)
      // 兼容没有结束时间的取出来
      if ((obj.timeOver || obj.timeOver === 0) && obj.timeOver >= 0) {
        return obj.data
      } else {
        return JSON.stringify(obj)
      }
    } catch (error) {
      return value
    }
  }
}

// 清除过期时间
export const cacheClear = () => {
  let date = new Date().getTime()
  for (var i = 0; i < localStorage.length; i++) {
    var key = localStorage.key(i)
    let value = localStorage.getItem(key)
    try {
      let obj = JSON.parse(value)
      if (obj.timeOver === 0) continue
      // 兼容没有结束时间的取出来
      if (date > obj.timeOver) {
        localStorage.removeItem(key)
      }
    } catch (error) {
      // 有报错老代码，不管他
    }
  }
}
/**
 * @method  是否忽略这些URL对应的请求错误
 * @param apiurl 请求地址
 */
export const isUrlIgnore = (apiurl) => {
  if (apiurl || apiurl === null || apiurl === 0) {
    return false
  } else {
    if (apiurl.indexOf('reportLogRecord') > -1 || apiurl.indexOf('unReadCount') > -1 || apiurl.indexOf('unReadTotal') > -1 || apiurl.indexOf('unReadAll') > -1 || apiurl.indexOf('unReadTotal') > -1 || apiurl.indexOf('listByType') > -1) {
      return true
    }
    return false
  }
}

/**
 * @method 用来本地存储和取值删除功能,传一个值是get两个值是set
 * @param {string} key 本地存键key值
 * @param {string} val 存储的值 传null值相当于清除函数
 */
export const sessionCache = (key, val) => {
  if (val || val === null || val === 0) {
    val === null ? sessionStorage.removeItem(key) : sessionStorage.setItem(key, val)
  } else {
    return sessionStorage.getItem(key)
  }
}

/**
 * @method 用来转化时间戳是时间变成YMDhms自己自由组合的字符串格式
 * @param {number} time 时间戳
 * @param {string} str Y M  D h m s自由组合的字符串随意组合
 * @param {string} noStr 传入时间不存在时返回的字符串
 */
export const timestampToStr = (time, str, noStr) => {
  if (!time) return noStr || ''
  const date = new Date(time)
  str = str.replace('Y', date.getFullYear())
  str = str.replace('M', (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1))
  str = str.replace('D', (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()))
  str = str.replace('h', (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()))
  str = str.replace('m', (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()))
  str = str.replace('s', (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()))
  str = str.replace('S', (date.getMilliseconds()))
  return str
}
/**
 * @method 用来转化时间戳是时间变成YMDhms自己自由组合的字符串格式
 * @param {number} time 时间戳
 * @param {string} str Y M  D h m s自由组合的字符串随意组合
 * @param {string} noStr 传入时间不存在时返回的字符串
 */
export const timestampToStr1 = (time, str, noStr) => {
  if (!time) return noStr || ''
  const date = new Date(time)
  str = str.replace('Y', date.getFullYear())
  str = str.replace('M', date.getMonth() + 1)
  str = str.replace('D', date.getDate())
  str = str.replace('h', date.getHours())
  str = str.replace('m', date.getMinutes())
  str = str.replace('s', date.getSeconds())
  str = str.replace('S', (date.getMilliseconds()))
  return str
}
/**
 * @method 获取服务端时间戳
 */
export const getTimestamp = () => {
  let date = new Date().getTime()
  let timeDiff = $store.state.common.timeDiff
  return date + timeDiff
}
export const getCurDiffTime = (sTime) => {
  let diffTime = new Date().getTime() - sTime
  if (diffTime > 0 && diffTime < 20) {
    return 0
  }
  return diffTime
}
/**
 * @method 传入剩余时间把他们转化为时分秒
 * @param {number} num 要转化剩余的毫秒数
 * @param {str} str    转化的格式h m s自由组合的字符串随意组合
*/
export const handleTime = (num, str) => {
  // 剩余总秒数
  num = Math.floor(num / 1000)
  const s = num % 60
  const m = Math.floor((num % 3600) / 60)
  const h = Math.floor(num / 3600)
  str = str.replace('h', (h < 10 ? '0' + h : h))
  str = str.replace('m', (m < 10 ? '0' + m : m))
  str = str.replace('s', (s < 10 ? '0' + s : s))
  return str
}
export const handleTimeD = (num, str) => {
  // 剩余总秒数
  let d = Math.floor(num / (1000 * 60 * 60 * 24))
  let h = Math.floor((num % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  let m = Math.floor((num % (1000 * 60 * 60)) / (1000 * 60))
  let s = Math.floor((num % (1000 * 60)) / 1000)
  if (d === 0) d = ''
  str = str.replace('d', d)
  str = str.replace('h', (h < 10 ? '0' + h : h))
  str = str.replace('m', (m < 10 ? '0' + m : m))
  str = str.replace('s', (s < 10 ? '0' + s : s))
  return str
}
/**
 *
 * @param {number} timer 需要转化的时间戳
 */
export const changeTime = (timer) => {
  timer = timer || 0
  let str = ''

  let d = Math.floor(timer / (1000 * 60 * 60 * 24))
  let h = Math.floor((timer % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  let m = Math.floor((timer % (1000 * 60 * 60)) / (1000 * 60))
  let s = Math.floor((timer % (1000 * 60)) / 1000)

  let day = d === 0 ? '' : d + '天'
  let hou = h < 10 ? '0' + h : h
  let min = m < 10 ? '0' + m : m
  let sec = s < 10 ? '0' + s : s
  str = day + hou + ':' + min + ':' + sec
  return str
}

/**
 * @method 用来数字变中文三位一个逗号
 * @param {number} num 需要数字转中文数字的
 * @return {string}  返回中文数字
 */
export const numberComma = (num) => {
  let str = ''
  let s1 = Math.floor(num / (1000 * 1000))
  let s2 = Math.floor((num % (1000 * 1000)) / 1000)
  let s3 = num % 1000
  if (s1 > 0) {
    let str1 = s1 + ''
    let str2 = s2 === 0 ? '000' : (s2 < 10 ? '00' + s2 : (s2 < 100 ? '0' + s2 : s2 + ''))
    let str3 = s3 === 0 ? '000' : (s3 < 10 ? '00' + s3 : (s3 < 100 ? '0' + s3 : s3 + ''))
    str = str1 + ',' + str2 + ',' + str3
  } else if (s2 > 0) {
    let str2 = s2 + ''
    let str3 = s3 === 0 ? '000' : (s3 < 10 ? '00' + s3 : (s3 < 100 ? '0' + s3 : s3 + ''))
    str = str2 + ',' + str3
  } else {
    str = s3 + ''
  }
  return str
}

/**
 * @method 用来返回的字符串长度中文字占2的长度
 * @param {number} num 需要返回字符串长度的
 * @return {string}  返回的字符串长度
 */
export const strLength = (str) => {
  let newStr = str.replace(/^[\u4e00-\u9fa5]$/g, 'aa')
  return newStr.length
}

/**
 * @method 用来数字变中文数字
 * @param {number} num 需要数字转中文数字的
 * @return {string}  返回中文数字
 */
export const numberChinese = (num) => {
  let str = ''
  switch (num) {
    case 0: str = '零'
      break
    case 1: str = '一'
      break
    case 2: str = '二'
      break
    case 3: str = '三'
      break
    case 4: str = '四'
      break
    case 5: str = '五'
      break
    case 6: str = '六'
      break
    case 7: str = '七'
      break
    case 8: str = '八'
      break
    case 9: str = '九'
      break
  }
  return str
}

/**
 * @method 检测是不是app环境
 * @return {boolean} true就是不在app false就是在app中
 */
export const getUserAgent = () => {
  let str = navigator.userAgent
  if (str.indexOf('Bloom_iOS') > -1) {   // ios
    return false
  } else if (str.indexOf('Bloom_Android') > -1) {  // Android
    return false
  } else {
    return true
  }
}

/**
 * @method 去字符串除前后空格
 * @return {String} 需要去除的字符串
 */
export const trim = (str) => {
  return str.replace(/(^\s*)|(\s*$)/g, '')
}

/**
 * @method app环境的登录
 */
export const appLogin = () => {
  if (window.webkit) {
    window.webkit.messageHandlers.popLogin.postMessage(null)
  }
  if (window.AndroidJSObject) {
    window.AndroidJSObject.login()
  }
}

/**
 * @method web向app环境的跳转业务
 * @param str string url加参数
 */
export const pushAPP = (str) => {
  let load = document.createElement('a')
  load.href = `sktbloom://push?ID=${str}`
  document.body.appendChild(load)
  load.click()
  document.body.removeChild(load)
}

/**
 * @method 通过文件名字寻找文件格式
 * @param {String} str 文件名
 * @returns {string}
 */
export const fileFormat = (str) => {
  const formatStr = str.split('.').pop() || ''
  if (formatStr === '') return 'unknown'
  const list = {
    excel: ['xls', 'xlsx'],
    pdf: ['pdf'],
    ppt: ['ppt', 'pptx'],
    word: ['doc', 'docx', 'wps'],
    video: ['mov', 'mp4'],
    zip: ['zip', 'rar'],
    music: ['mp3'],
    img: ['png', 'jpg', 'jpge']
  }
  for (let i in list) {
    if (list[i].indexOf(formatStr) > -1) {
      return i
    }
  }
  return 'unknown'
}

/**
 * @method 过滤非法输入
 * @param {String} str 需要过滤的字符串
 * @returns {string}
 */
export const filterInput = (str) => {
  str = str.replace('&', ' &amp;')
  str = str.replace(' ', '&nbsp;')
  str = str.replace('<', '&lt;')
  str = str.replace('>', '&gt;')
  str = str.replace(/[\n\r]/g, '<br/>')
  return str
}

/**
 * 增强版倒计时函数 - 支持页面关闭时自动清除定时器
 * @param {number} seconds - 剩余秒数
 * @param {function} updateCallback - 每秒更新的回调函数
 * @param {function} endCallback - 倒计时结束的回调函数
 */
export const enhancedCountdown = (seconds, updateCallback, endCallback) => {
  let remainingSeconds = seconds
  let timer = null

  // 清除定时器的函数
  function clearTimer () {
    if (timer) {
      clearInterval(timer)
      timer = null
    }
  }

  // 页面关闭/刷新时清除定时器
  window.addEventListener('beforeunload', clearTimer)
  window.addEventListener('unload', clearTimer)

  // 倒计时结束时的清理工作
  function finishCountdown () {
    clearTimer()
    // 移除事件监听器，避免内存泄漏
    window.removeEventListener('beforeunload', clearTimer)
    window.removeEventListener('unload', clearTimer)

    if (endCallback) {
      endCallback()
    }
  }

  timer = setInterval(() => {
    remainingSeconds--

    // 每秒更新回调
    if (updateCallback) {
      updateCallback(remainingSeconds)
    }

    // 倒计时结束
    if (remainingSeconds <= 0) {
      finishCountdown()
    }
  }, 1000)

  // 返回一个可以手动停止倒计时的方法
  return {
    stop: function () {
      finishCountdown()
    },
    getRemaining: function () {
      return remainingSeconds
    }
  }
}

/** 全屏打开浏览器 判断各种浏览器，找到正确的打开方法
 * @method launchFullscreen
 */
export const launchFullscreen = () => {
  let element = document.documentElement
  if (element.requestFullscreen) {
    element.requestFullscreen()
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen()
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen()
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen()
  }
}
/** 退出全屏浏览器 判断各种浏览器，找到正确的关闭方法
 * @method exitFullscreen
 */
export const exitFullscreen = () => {
  if (document.exitFullscreen) {
    document.exitFullscreen()
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen()
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen()
  }
}
/** decodeURIComponent
 * @method 返回decodeURIComponent过的url
 */
export const urlDecode = (url) => {
  if (url) {
    // return decodeURIComponent(url)
    return url
  }
  return ''
}
// export const _throttle = (fn, interval) => {
//   var last
//   var timer
//   interval = interval || 200
//   return function () {
//     var th = this
//     var args = arguments
//     var now = +new Date()
//     if (last && now - last < interval) {
//       clearTimeout(timer)
//       timer = setTimeout(function () {
//         last = now
//         fn.apply(th, args)
//       }, interval)
//     } else {
//       last = now
//       fn.apply(th, args)
//     }
//   }
// }

// base64 转 blob
export const dataURItoBlob = (dataURI) => {
  // convert base64/URLEncoded data component to raw binary data held in a string
  let byteString
  if (dataURI.split(',')[0].indexOf('base64') >= 0) {
    byteString = atob(dataURI.split(',')[1])
  } else byteString = unescape(dataURI.split(',')[1])

  // separate out the mime component
  const mimeString = dataURI
    .split(',')[0]
    .split(':')[1]
    .split(';')[0]

  // write the bytes of the string to a typed array
  const ia = new Uint8Array(byteString.length)
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }
  return new Blob([ia], { type: mimeString })
}

export const blobToFile = (theBlob, fileName) => {
  theBlob.lastModifiedDate = new Date()
  theBlob.originalFilename = fileName
  theBlob.name = fileName
  return theBlob
}
//
export const timeToStr = (t = 0) => {
  if (isNaN(t)) return ''
  t = Math.floor(t)
  let h = Math.floor(t / 3600)
  let m = Math.floor((t % 3600) / 60)
  let s = t % 60
  h = h > 9 ? h : `0${h}`
  m = m > 9 ? m : `0${m}`
  s = s > 9 ? s : `0${s}`
  if (h === '00') {
    return `${m} : ${s}`
  } else {
    return `${h} : ${m} : ${s}`
  }
}

export const Value2Json = (value, logFn) => {
  let str = ''
  try {
    str = JSON.stringify(value)
  } catch (err) {
    let data = {
      a: 1010, // ---考试存在
      c: {
        msg: err.message || 'Json解析出错',
        value
      },
      r: '/'
    }
    logFn(data)
  }
  return str
}

export const Json2Value = (value, logFn) => {
  let str = ''
  try {
    str = JSON.parse(value)
  } catch (err) {
    let data = {
      a: 1011, // ---考试存在
      c: {
        msg: err.message || 'Json解析出错',
        value
      },
      r: '/'
    }
    logFn(data)
  }
  return str
}

// 与 index.html 中 CNZZ 数据层一致，未加载时 push 到队列
let _czc = window._czc || []
export const CzcTrackEvent = (category, action, label = '') => {
  console.log(category, action, label)
  try {
    if (!_czc) return
    _czc.push(['_trackEvent', category, action, label])
  } catch (error) {
    console.log(error)
  }
}

export const dataURLtoFile = (dataUrl, filename) => {
  // 获取到base64编码
  let base64Str = dataUrl.split(',')
  // 将base64编码转为字符串
  let decodeStr = atob(base64Str[1])
  let n = decodeStr.length
  // 创建初始化为0的，包含length个元素的无符号整型数组
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = decodeStr.charCodeAt(n)
  }
  return new File([u8arr], filename, {
    type: 'image/jpeg'
  })
}

/**
 * @method 获取音频文件格式
 * @param {String} url 音频文件
 * @returns {string}
 */
export const getAudioFormat = (url) => {
  return new Promise((resolve, reject) => {
    const audio = new Audio()
    audio.src = url
    audio.onerror = () => reject(new Error('音频加载错误'))
    audio.onloadedmetadata = () => {
      // 当音频的元数据已加载时，获取其格式信息
      const format = audio.src.split('.').pop() // 假设格式是文件扩展名
      resolve(format)
    }
  })
}

/**
 * @method 检测音频文件是否存在
 * @param {String} url 音频文件
 * @returns {string}
 */
export const checkAudioExists = (url) => {
  return new Promise((resolve, reject) => {
    var audio = new Audio()
    audio.onerror = function () {
      reject(new Error('音频文件不存在'))
    }
    audio.oncanplaythrough = function () {
      resolve(true)
    }
    audio.src = url
  })
}
/**
 * @method 通过图片地址下载图片功能
 * @param url {string}
 * @returns {string}
 */
export const  downloadImgByUrl = (url) => {
  return new Promise((resolve, reject) => {
    try {
      let imageUrl = url
      let image = new Image()
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = function () {
        let canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        let context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        let url = canvas.toDataURL('image/png') // 得到图片的base64编码数据
        let a = document.createElement('a') // 生成一个a元素
        let event = new MouseEvent('click') // 创建一个单击事件
        a.download = name || 'photo' // 设置图片名称
        a.href = url // 将生成的URL设置为a.href属性
        a.dispatchEvent(event) // 触发a的单击事件
      }
      image.src = imageUrl
      resolve(true)
    } catch (err) {
      reject(err)
      console.log(err)
    }
  })
}
// 传入一个时间戳判断是不是年月日是不是今天
export const isToday = (timestamp) => {
  let targetDate = new Date(timestamp)
  let today = new Date()
  return (
    targetDate.getFullYear() === today.getFullYear() &&
    targetDate.getMonth() === today.getMonth() &&
    targetDate.getDate() === today.getDate()
  )
}



// WEBPACK FOOTER //
// ./src/assets/utils/utils.js